const TRACK_COLORS = ["#d81b60", "#2563eb", "#16a34a", "#f97316", "#7c3aed", "#0891b2"];

export function createMap(mapEl) {
  if (!window.L) {
    throw new Error("Leaflet failed to load.");
  }

  const map = L.map(mapEl, {
    zoomControl: true,
    preferCanvas: true,
    scrollWheelZoom: false,
  }).setView([39.8283, -98.5795], 4);

  const baseMaps = {
    Topo: L.tileLayer("https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png", {
      maxZoom: 20,
      crossOrigin: "anonymous",
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, CyclOSM',
    }),
    "OSM Standard": L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      crossOrigin: "anonymous",
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }),
    "Satellite (ESRI)": L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
      maxZoom: 19,
      attribution: "Tiles &copy; Esri",
    }),
    "Topo (ESRI)": L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}", {
      maxZoom: 19,
      attribution: "Tiles &copy; Esri",
    }),
  };

  baseMaps["Topo (ESRI)"].addTo(map);
  L.control.layers(baseMaps, null, { collapsed: false, position: "topright" }).addTo(map);
  L.control.scale({ metric: true, imperial: true, position: "bottomleft" }).addTo(map);

  let layerGroup = L.featureGroup().addTo(map);

  setTimeout(() => map.invalidateSize(), 50);
  window.addEventListener("resize", () => map.invalidateSize());

  return {
    clear() {
      map.removeLayer(layerGroup);
      layerGroup = L.featureGroup().addTo(map);
    },
    addProfile(profile, options = {}) {
      const color = options.color || TRACK_COLORS[0];
      profile.segments.forEach((segment) => {
        L.polyline([
          [segment.from.latitude, segment.from.longitude],
          [segment.to.latitude, segment.to.longitude],
        ], {
          color,
          lineCap: "round",
          lineJoin: "round",
          opacity: 0.95,
          smoothFactor: 1,
          weight: 4,
        }).addTo(layerGroup);
      });
    },
    addSplitMarkers(points) {
      points.forEach((point, index) => {
        L.circleMarker([point.latitude, point.longitude], {
          color: "#111827",
          fillColor: "#ffffff",
          fillOpacity: 1,
          radius: 7,
          weight: 3,
        })
          .bindTooltip(`Split ${index + 1}`, { direction: "top", offset: [0, -8] })
          .addTo(layerGroup);
      });
    },
    fit() {
      const bounds = layerGroup.getBounds();
      if (bounds.isValid()) {
        map.fitBounds(bounds, { padding: [20, 20] });
      }
    },
    getColor(index) {
      return TRACK_COLORS[index % TRACK_COLORS.length];
    },
  };
}
